module.exports = __webpack_public_path__ + "04_long_yellow.c393f4e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer5/04_long_yellow.png
// module id = pMrR
// module chunks = 0